module.exports = __webpack_public_path__ + "media/images/folder-2543303842559171f1af2f9e210f78a1.png";